exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-message[data-v-20f19cd6] {\n  width: 100%;\n  text-align: center;\n  font-size: 17px;\n  color: #777;\n  line-height: 18px;\n  margin: 35px 0;\n}\n", ""]);

// exports
